// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3Yme-","productName":"Table_productName__3BUII"};